import { render, staticRenderFns } from "./DashboardErp.vue?vue&type=template&id=798df5f8&scoped=true"
import script from "./DashboardErp.vue?vue&type=script&lang=js"
export * from "./DashboardErp.vue?vue&type=script&lang=js"
import style0 from "./DashboardErp.vue?vue&type=style&index=0&id=798df5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798df5f8",
  null
  
)

export default component.exports